var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"donate-btn",class:{ selected: _vm.value == _vm.selected },attrs:{"value":_vm.value},on:{"click":function($event){return _vm.$emit('click', _vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }